import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SmallClipControls } from '../SmallClipControls/SmallClipControls';
import { getScreenshotSignedUrl, getClipListens } from '../../services/HalogenService';
import { FormatDate } from '../../helpers/FormatDate';
import './SmallClip.css';

export const SmallClip = ({ clip }) => {
    const navigate = useNavigate();
    const [screenshotUrl, setScreenshotUrl] = useState(clip.imageURL);
    const [numListens, setNumListens] = useState(clip.numListens ? clip.numListens : 0);
    const [isImgLoading, setIsImgLoading] = useState(true);

    const handleNavigate = () => {
        navigate(`/focus/${clip.id}`);
    };

    useEffect(() => {
        if (!clip.imageURL) {
            getScreenshotSignedUrl(clip.id, 'xsmall')
                .then(url => {
                    setScreenshotUrl(url.signedUrl);
                    setIsImgLoading(true);
                })
                .catch(err => console.error(err));
        }
        if (clip.numListens === undefined) {
            getClipListens(clip.id)
                .then(listens => setNumListens(listens.listens))
                .catch(err => console.error(err));
        }
    }, [clip.id, clip.imageURL, clip.numListens]);

    return (
        <div onClick={handleNavigate} className="smallClipContainer">
            <div className="smallClipContentContainer">
                {/* {isImgLoading && <div className="imagePlaceholder">Loading...</div>} */}
                {isImgLoading && <div className="imagePlaceholder"></div>}
                {screenshotUrl && <img
                    src={screenshotUrl}
                    alt="Visual Content"
                    className={`smallClipVisualContentImg ${isImgLoading ? 'hidden' : ''}`}
                    onLoad={() => setIsImgLoading(false)}
                />}
                <h4 className="smallClipTitle">{clip.title}</h4>
                <p className="smallClipDetails">
                    {FormatDate(clip.created_at)} | {numListens} listens
                </p>
                <div onClick={(e) => e.stopPropagation()} className="smallClipControlsContainer">
                    <SmallClipControls clip={clip} color={'#F2EFF4'}/>
                </div>
            </div>
        </div>
    );
};